// extracted by mini-css-extract-plugin
module.exports = {"componentsMapCarousel":"styles_componentsMapCarousel__1lA6i"};